import { submitStateActionTypes } from './ActionTypes';
export var initialState = {
    type: submitStateActionTypes.INITIAL_SUBMIT_STATE
};
